import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import 'mediaelement';
// Import stylesheet and shims
import 'mediaelement/build/mediaelementplayer.min.css';
import 'mediaelement/build/mediaelement-flash-video.swf';

const MediaElement = ({
  id,
  preload,
  controls,
  width,
  height,
  poster,
  options,
  source,
}) => {
  const [player, setPlayer] = useState(null);
  const success = (media, node, instance) => {
    // Your action when media was successfully loaded
  };
  const error = (media) => {
    // Your action when media had an error loading
  };

  useEffect(() => {
    const { MediaElementPlayer } = window;
    if (!MediaElementPlayer) {
      return false;
    }

    const playerOptions = {
      ...JSON.parse(options), // Just in case we need to customize this further
      pluginPath: './static/media/',
      success: (media, node, instance) => success(media, node, instance),
      error: (media, node) => error(media, node),
    };

    setPlayer(new MediaElementPlayer(id, playerOptions));
    return () => {
      if (player) {
        player.remove();
        setPlayer(null);
      }
    };
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [id, options]);

  return (
    /* eslint-disable jsx-a11y/media-has-caption */
    <video
      id={id}
      width={width}
      height={height}
      poster={poster}
      controls={controls}
      preload={preload}
    >
      <source src={source.src} type={source.type} />
    </video>
  );
};

MediaElement.defaultProps = {
  id: 'player1',
  preload: 'auto',
  controls: true,
  width: '100%',
  height: '100%',
  poster: '',
  options: {},
};

MediaElement.propTypes = {
  id: PropTypes.string,
  preload: PropTypes.string,
  controls: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  poster: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  source: PropTypes.shape({
    src: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  options: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default MediaElement;
